// «Идея-мастер» — клиент трёхшагового генератора идей (темы → идеи → промпт).
// Экономика: N бесплатных циклов в день, дальше платно с ЯВНЫМ подтверждением
// (бэк возвращает need_payment, списание только при acceptCharge=true).
import { api } from './client'
import type { Model } from '../data/models'

export interface IdeaStatus {
	free_limit: number
	free_used: number
	free_left: number
	price_credits: number
}

export interface IdeaItem {
	title: string
	desc: string
}

export interface IdeaSettings {
	aspect_ratio: string | null
	duration: string | null
	sound: boolean | null
}

export interface IdeaContext {
	model_id: string
	model_name: string
	adapter: string
	model_type: 'image' | 'video' | 'audio' | 'presentation'
	aspect_ratios: string[]
	durations: string[]
	supports_audio: boolean
}

/** Контекст мастера из выбранной модели виджета. */
export function buildIdeaContext(m: Model): IdeaContext {
	const type = m.category === 'video' || m.category === 'audio' || m.category === 'presentation' ? m.category : 'image'
	return {
		model_id: m.id,
		model_name: m.name,
		adapter: m.adapter || m.provider,
		model_type: type,
		aspect_ratios: m.aspectRatios || [],
		durations: m.durations || [],
		supports_audio: !!m.supportsAudio,
	}
}

/** Вариант готового промпта (шаг 3 может отдавать несколько за один вызов) */
export interface IdeaVariant {
	prompt: string
	settings: IdeaSettings
}

export interface IdeaStageResponse {
	ok: boolean
	session_id?: string
	// стадии
	themes?: string[]
	ideas?: IdeaItem[]
	prompt?: string
	settings?: IdeaSettings
	/** Все варианты промпта; prompt/settings выше = первый (старый контракт) */
	variants?: IdeaVariant[]
	// счётчики/оплата
	attempts_left?: number
	free_left?: number
	free_limit?: number
	/** Цена платной перегенерации шага — приходит со стартовым themes-ответом */
	step_price_credits?: number
	need_payment?: boolean
	// 'step' — платная поштучная перегенерация шага (сверх 3 бесплатных попыток);
	// без scope — платный ЦИКЛ (кончились бесплатные циклы дня).
	scope?: 'step'
	price_credits?: number
	error?: string
}

export async function getIdeaStatus(): Promise<IdeaStatus> {
	return api.request<IdeaStatus & { ok: boolean }>('/api/v1/prompts/idea/status', { method: 'GET' })
}

export async function ideaStage(params: {
	stage: 'themes' | 'ideas' | 'prompt'
	sessionId?: string | null
	acceptCharge?: boolean
	context: IdeaContext
	theme?: string
	idea?: IdeaItem | null
}): Promise<IdeaStageResponse> {
	return api.request<IdeaStageResponse>('/api/v1/prompts/idea', {
		method: 'POST',
		body: {
			stage: params.stage,
			session_id: params.sessionId || null,
			accept_charge: !!params.acceptCharge,
			context: params.context,
			theme: params.theme || null,
			idea_title: params.idea?.title || null,
			idea_desc: params.idea?.desc || null,
		},
	})
}
